export const projects = [
  {
    id: 14,
    title: 'Sunset Park Driveway',
    subtitle: 'Spanish Revival',
    category: 'Driveways',
    thumb: 'https://www.parksidepavers.com/files/projects/14/thumb/thumb_IMG%5F2835%2Dlanding%2Ejpg',
    large: 'https://www.parksidepavers.com/files/projects/14/images/thumb/thumb_large_IMG%5F2835%2Ejpg',
    material: 'Flagstone CityStone Demi 3-Piece Pavers',
  },
  {
    id: 15,
    title: 'Lanai',
    subtitle: 'Pool Lanai',
    category: 'Patios',
    thumb: 'https://www.parksidepavers.com/files/projects/15/thumb/thumb_Albano%2Dlanai%2Dlanding%2Ejpg',
    large: 'https://www.parksidepavers.com/files/projects/15/images/thumb/thumb_large_Albano%2Dlanai%2Ejpg',
    material: 'Tremron Olde Towne 2-Piece Pavers',
  },
  {
    id: 16,
    title: 'Beach Park Driveway',
    subtitle: 'Key West Rustic',
    category: 'Driveways',
    thumb: 'https://www.parksidepavers.com/files/projects/16/thumb/thumb_IMG%5F2840%2Dlanding%2Ejpg',
    large: 'https://www.parksidepavers.com/files/projects/16/images/thumb/thumb_large_IMG%5F2840%2Ejpg',
    material: 'Flagstone CityStone Demi 3-Piece Pavers',
  },
  {
    id: 17,
    title: 'Front Walk',
    subtitle: 'Walkway Entrance',
    category: 'Walkways',
    thumb: 'https://www.parksidepavers.com/files/projects/17/thumb/thumb_IMG%5F0274%2Dlanding%2Ejpg',
    large: 'https://www.parksidepavers.com/files/projects/17/images/thumb/thumb_large_IMG%5F0274%2EJPG',
    material: 'Belgard Appian Stone 2-Piece Pavers',
  },
];
